export const messages = {
  empty: {
    description: {
      id: 'admin/promotions.form.progressive-discount.view.empty-description',
    },
    addItems: {
      id: 'admin/promotions.form.utils.add-items',
    },
  },
  trigger: {
    description: {
      id: 'admin/promotions.form.progressive-discount.view.trigger.description',
    },
  },
  benefit: {
    description: {
      id: 'admin/promotions.form.progressive-discount.view.benefit.description',
    },
    percentualTitle: {
      id: 'admin/promotions.form.progressive-discount.view.benefit.percentual',
    },
    itemAndDiscount: {
      id: 'admin/promotions.form.progressive-discount.view.benefit.percentual.item-discount',
    },
  },
}
